import { render, staticRenderFns } from "./ModalShowClaim.vue?vue&type=template&id=5e9de4c7&lang=pug&"
import script from "./ModalShowClaim.vue?vue&type=script&lang=js&"
export * from "./ModalShowClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports